(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[51367],{

/***/ 78677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Wireframes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./components/CaseStudiesCommon/utils/data.js
var data = __webpack_require__(27515);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/components/Wireframes/utils/herlpers.js
var DEFAULT_MOBILE_IMAGE_SIZE = 350;
var DEFAULT_IMAGE_SIZE = 500;
var IMAGE_SIZES = {
    "marketplace-for-clairvoyant-services": 541,
    fernwayer: {
        default: 478,
        secondSectionView: 650
    },
    fireaway: {
        default: 425
    },
    dindon: {
        default: 440
    },
    "seven-pm-thursday": {
        default: 478
    },
    stickerbox: {
        default: 480
    },
    fairy: {
        default: 478
    },
    "open-sense": {
        default: 440
    },
    "drive-focus": {
        default: 440
    },
    tell: {
        default: 478
    },
    "travel-trivia": {
        default: 478
    },
    "cash-chat": {
        default: 478
    },
    beautonomy: 600,
    meateater: {
        default: 470
    },
    "separate-us": {
        default: 440
    },
    "fintech-app-for-credit-score": {
        default: 480
    },
    ubichat: {
        default: 500
    },
    telemojo: {
        default: 440
    },
    famlicious: 478,
    bionorica: {
        default: 500
    },
    humankind: {
        default: 515
    },
    blackbird: {
        default: 480
    },
    "software-for-mri-interpretation": 630,
    "fusion-markets": {
        default: 440
    },
    "machine-learning-in-real-estate": {
        sixthSectionView: 480
    },
    "mobile-bank-application": {
        default: 586
    },
    "forex-trading-platform": {
        default: 560
    },
    "kitchen-equipment-customizer": {
        default: 622
    },
    "mobile-music-app": {
        firstSectionView: 600,
        secondSectionView: 100
    },
    "medical-software-for-musculoskeletal-rehabilitation": {
        default: 600
    },
    "ai-software-development-services": {
        firstSectionView: 208
    },
    "ai-documentation-processing": {
        firstSectionView: 522
    }
};
var MOBILE_IMAGE_SIZES = {
    fireaway: {
        default: 250
    },
    tell: {
        default: 350
    },
    "separate-us": {
        default: 180
    },
    "drive-focus": {
        default: 220
    },
    ubichat: {
        default: 220
    },
    "marketplace-for-clairvoyant-services": {
        default: 206
    },
    "fusion-markets": {
        default: 206
    },
    telemojo: {
        default: 206
    },
    blackbird: {
        default: 350
    },
    dindon: {
        default: 181
    },
    humankind: {
        default: 181
    },
    "machine-learning-in-real-estate": {
        sixthSectionView: 240
    },
    "mobile-bank-application": {
        default: 550
    },
    "forex-trading-platform": {
        default: 228
    },
    meateater: {
        default: 211
    },
    "kitchen-equipment-customizer": {
        default: 206
    },
    "mobile-music-app": {
        firstSectionView: 600,
        secondSectionView: 40
    },
    "medical-software-for-musculoskeletal-rehabilitation": {
        default: 320
    },
    "ai-software-development-services": {
        firstSectionView: 188
    },
    "ai-documentation-processing": {
        firstSectionView: 206
    }
};

;// CONCATENATED MODULE: ./UI/components/Wireframes/utils/useWireframes.js






var useWireframes = function(param) {
    var images = param.images, type = param.type, view = param.view;
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var wireframeImages = images === null || images === void 0 ? void 0 : images.map(function(image) {
        var ref, ref1;
        var imageData = (0,helper/* getImage */.gJ)(image);
        var height = isMobileResolution ? ((ref = MOBILE_IMAGE_SIZES[type]) === null || ref === void 0 ? void 0 : ref[view || "default"]) || DEFAULT_MOBILE_IMAGE_SIZE : ((ref1 = IMAGE_SIZES[type]) === null || ref1 === void 0 ? void 0 : ref1[view || "default"]) || DEFAULT_IMAGE_SIZE;
        var scale = height / imageData.height;
        var width = Math.trunc(imageData.width * scale);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
            width: width,
            height: height
        });
    });
    return {
        type: type,
        images: images,
        wireframeImages: wireframeImages,
        isMobileResolution: isMobileResolution
    };
};

// EXTERNAL MODULE: ./UI/components/Wireframes/styles.module.scss
var styles_module = __webpack_require__(5665);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Wireframes/index.jsx










var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Wireframe = function(props) {
    var ref = useWireframes(props), type = ref.type, wireframeImages = ref.wireframeImages;
    if (!wireframeImages) {
        return null;
    }
    return wireframeImages === null || wireframeImages === void 0 ? void 0 : wireframeImages.map(function(param) {
        var url = param.url, alt = param.alt, height = param.height, width = param.width;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            delay: 100
        }, data/* ANIMATION_CASE_STUDY_PROPS */.e), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((styles_module_default())[type], (styles_module_default()).container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: url,
                        alt: alt,
                        layout: "responsive",
                        style: {
                            minWidth: "".concat(width, "px"),
                            height: "".concat(height, "px")
                        },
                        width: width,
                        height: height,
                        containerClasses: (styles_module_default()).animatedContainer,
                        className: (styles_module_default()).image,
                        unoptimized: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                        src: url,
                        alt: alt,
                        layout: "responsive",
                        style: {
                            minWidth: "".concat(width, "px"),
                            height: "".concat(height, "px")
                        },
                        width: width,
                        height: height,
                        containerClasses: (styles_module_default()).animatedContainer,
                        className: (styles_module_default()).image,
                        unoptimized: true
                    })
                ]
            })
        }), url);
    });
};
Wireframe.propTypes = {
    images: prop_types_default().arrayOf(prop_types_default().instanceOf(Object)).isRequired,
    type: (prop_types_default()).string.isRequired,
    view: (prop_types_default()).string
};
/* harmony default export */ var Wireframes = (Wireframe);


/***/ }),

/***/ 64757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_WireframesSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx + 1 modules
var SectionTitle = __webpack_require__(36837);
// EXTERNAL MODULE: ./UI/components/Wireframes/index.jsx + 2 modules
var Wireframes = __webpack_require__(78677);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/sections/WireframesSection/styles.module.scss
var styles_module = __webpack_require__(67564);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/WireframesSection/utils/useWireframesSection.js




var useWireframesSection = function(param) {
    var section = param.section, data = param.data, type = param.type;
    var ref = (0,helper/* getDocumentFields */.OA)(data || section, [
        "title",
        "subtitle",
        "description",
        "images",
        "view", 
    ], {
        isNormilized: data
    }), title = ref.title, subtitle = ref.subtitle, description = ref.description, images = ref.images, view = ref.view;
    var sectionBackgroundImage = (0,helper/* getOptimizedContentfulImage */.kd)((0,helper/* getFileUrl */.qm)(get_default()(data, "background", {})), {
        fm: "png"
    });
    var sectionProps = {
        style: sectionBackgroundImage ? {
            backgroundImage: "url(".concat(sectionBackgroundImage, ")")
        } : {},
        className: classnames_default()((styles_module_default())[type], (styles_module_default())[view], (styles_module_default()).container)
    };
    return {
        type: type,
        view: view,
        title: title,
        images: images,
        subtitle: subtitle,
        description: description,
        sectionProps: sectionProps
    };
};

;// CONCATENATED MODULE: ./UI/sections/WireframesSection/index.jsx









var WireframesSection = function(props) {
    var ref = useWireframesSection(props), type = ref.type, view = ref.view, title = ref.title, images = ref.images, description = ref.description, subtitle = ref.subtitle, sectionProps = ref.sectionProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sectionProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                title: title,
                subtitle: subtitle,
                description: description,
                type: type,
                titleStyle: (styles_module_default()).titleStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wireframes/* default */.Z, {
                images: images,
                type: type,
                view: view
            })
        ]
    }));
};
WireframesSection.prototype = {
    data: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_WireframesSection = (WireframesSection);


/***/ }),

/***/ 5665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ZQHkg","animatedContainer":"styles_animatedContainer__WYfJB","image-scroll":"styles_image-scroll__pUNL8","stickerbox":"styles_stickerbox__y5DTR","image":"styles_image__bGCuA","fireaway":"styles_fireaway__l2P6I","seven-pm-thursday":"styles_seven-pm-thursday___Cl7g","open-sense":"styles_open-sense__Yklmv","drive-focus":"styles_drive-focus__12y7P","separate-us":"styles_separate-us__TLw4a","ubichat":"styles_ubichat__jbYPB","bionorica":"styles_bionorica__SM7Vw","fusion-markets":"styles_fusion-markets__H5xo9","beautonomy":"styles_beautonomy__ymseQ","meateater":"styles_meateater__qWYXE","mobile-music-app":"styles_mobile-music-app__hRFB5","blinking":"styles_blinking__7Ds4t","swing":"styles_swing__rXIHm","animateborder":"styles_animateborder__DhniH","animateborder-overlay":"styles_animateborder-overlay__8FnUW","animatecircle":"styles_animatecircle__kwr9O","animatedot":"styles_animatedot__9xDD6","animStar":"styles_animStar__EbuN6","hideText":"styles_hideText__hmhu8","spin":"styles_spin__8Cp8N","outOfTransparencyDesktop":"styles_outOfTransparencyDesktop__vtAMq","outOfTransparencyMobile":"styles_outOfTransparencyMobile__lpcr9","appearance":"styles_appearance__bMdbB","appearanceFromBelow":"styles_appearanceFromBelow__FL2aE","flicker":"styles_flicker__IS6Zf","vibrate1":"styles_vibrate1__jFR_O","rocket":"styles_rocket__zssUG","burgerItem1":"styles_burgerItem1__fTxlS","burgerItem2":"styles_burgerItem2__O_WVU","burgerItem3":"styles_burgerItem3__nrRQL","burgerItem1Reverse":"styles_burgerItem1Reverse__UKx57","burgerItem2Reverse":"styles_burgerItem2Reverse__IOcVP","burgerItem3Reverse":"styles_burgerItem3Reverse__O0X_q","arrow-down":"styles_arrow-down__7dLP_","image-scroll-reverse":"styles_image-scroll-reverse__Lo_CU","stickerbox-pointer-move":"styles_stickerbox-pointer-move__Un_to","hide-image":"styles_hide-image__bPthP","stickerbox-pointer-second":"styles_stickerbox-pointer-second__Yn3ZV","stickerbox-pointer-third":"styles_stickerbox-pointer-third__OBnx_","cedar-bounce":"styles_cedar-bounce__so6an"};

/***/ }),

/***/ 67564:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__aw_1N","titleStyle":"styles_titleStyle__ePgGy","stickerbox":"styles_stickerbox__Xw87A","fairy":"styles_fairy__1QZty","fireaway":"styles_fireaway__Bk4HP","seven-pm-thursday":"styles_seven-pm-thursday__BU9eg","fernwayer":"styles_fernwayer__C1ZKC","open-sense":"styles_open-sense__asNoo","separate-us":"styles_separate-us__QNULL","famlicious":"styles_famlicious__1guC6","drive-focus":"styles_drive-focus__oEqif","travel-trivia":"styles_travel-trivia__MPcaQ","tell":"styles_tell__TOZf6","cash-chat":"styles_cash-chat__LXfad","ubichat":"styles_ubichat__0eUdZ","meateater":"styles_meateater__R_CjR","bionorica":"styles_bionorica__7_Xk3","fusion-markets":"styles_fusion-markets__Ct_XJ","beautonomy":"styles_beautonomy__KfBgs","image":"styles_image__QiXOA","telemojo":"styles_telemojo__eNYp_","blackbird":"styles_blackbird__SD8Ic","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__71Av5","dindon":"styles_dindon__Y7b3x","mobile-bank-application":"styles_mobile-bank-application__3Yv7f","humankind":"styles_humankind__CAU9R","titleStyles":"styles_titleStyles__LKr2d","forex-trading-platform":"styles_forex-trading-platform__E_nAq","kitchen-equipment-customizer":"styles_kitchen-equipment-customizer__itSCb","mobile-music-app":"styles_mobile-music-app__kWvnB","firstSectionView":"styles_firstSectionView__aFCYe","secondSectionView":"styles_secondSectionView__xMNq9","medical-software-for-musculoskeletal-rehabilitation":"styles_medical-software-for-musculoskeletal-rehabilitation__Mr8cV","ai-software-development-services":"styles_ai-software-development-services__gVw_v"};

/***/ })

}]);